import { NATURE_OF_OPERATIONS_OPTIONS, type NatureOfOperation } from '../constants/organization';

const natureOfOperationSet = new Set<string>(Object.values(NATURE_OF_OPERATIONS_OPTIONS));

export function isNatureOfOperation(value: string): value is NatureOfOperation {
  return natureOfOperationSet.has(value);
}

export function toNatureOfOperation(value: string | null | undefined): NatureOfOperation | null {
  if (typeof value !== 'string' || !isNatureOfOperation(value)) return null;
  return value;
}

export function toNatureOfOperations(
  values: readonly string[] | null | undefined
): NatureOfOperation[] {
  if (!values) return [];
  return values.filter(isNatureOfOperation);
}
